module.exports = __webpack_public_path__ + "static/media/cta.5bfaea2f.svg";